import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { registeredUserConfirmationPageQueryOptions } from "~/app/api/pageData/registeredUserConfirmationPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { RegisterFreeSuccessPageView } from "~/pages/RegisterFreeSuccessPage/RegisterFreeSuccessPage";

function RegisteredUserConfirmationRoute() {
  const result = useLoaderData({
    from: "/registered/user/confirmation",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <RegisterFreeSuccessPageView />
    </StorefrontShellFrame>
  );
}

export async function loadRegisteredUserConfirmationPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(registeredUserConfirmationPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const registeredUserConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/registered/user/confirmation",
  loader: async ({ context }) => loadRegisteredUserConfirmationPageData(context),
  component: RegisteredUserConfirmationRoute,
});
